import { ark as r } from "@ark-ui/react";
import { styled as o } from "@huspy/styled-system/jsx";
import { propertyTag as t } from "@huspy/styled-system/recipes";
const i = o(r.div, t);
export {
  i as PropertyTag
};
